import React from 'react';
import PropTypes from 'prop-types';
import { cx, css } from 'emotion';
import { sanitizeUrl } from '@braintree/sanitize-url';

const textStyles = css({
  textDecoration: 'none',
  color: 'var(--color)',
  ':hover': {
    color: 'var(--hover-color)',
  },
});

function Link(props) {
  const { children, href, color, hoverColor, className } = props;

  return (
    <a
      href={sanitizeUrl(href)}
      target="_blank"
      rel="noopener"
      className={cx(textStyles, className)}
      style={{
        '--color': color,
        '--hover-color': hoverColor,
      }}
    >
      {children}
    </a>
  );
}

Link.propTypes = {
  children: PropTypes.any,
  href: PropTypes.string,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
};

export default React.memo(Link);
